$(document).ready(function() {
	/*
	 * General functionality used across the
	 * entire Applicaiton
	 */
	$('body').on('click', '.delete', function() {
		if (!confirm('Are you sure you want to delete?')) {
			return false;
		}
	});
	let progress = $('#dashboard .overlook .list li .progress');
	progress.find('.fill').animate(
		{
			width: progress.data('progress') + '%'
		},
		700
	);

	if (navigator.appVersion.indexOf('Chrome/') != -1) {
		$('#dashboard .photos').css({ left: '60px' });
	}

	// Highlight selected nav link
	$('.bar').each(function() {
		$(this)
			.find('.fill')
			.animate({ width: $(this).data('value') + '%' }, 1000);
	});		

	$('.photos').on('click', '.photo', function() {
		$('.photo-popup[data-id="' + $(this).data('id') + '"]').show();
	});

	$('.photos').on(
		'click',
		'.photo-popup .background, .photo-popup .exit',
		function() {
			$('.photo-popup').hide();
		}
	);	
});

//Make line beside logo that overlaps main content disappear on scroll
$(function() {
	$(window).scroll(function() {
		var topHeight = $('#header').height();
		var scroll = $(window).scrollTop();
		if (scroll >= topHeight) {
			$('#header .logo').css('padding-bottom', '17px');
		}
		if (scroll < topHeight) {
			$('#header .logo').css('padding-bottom', '37px');
		}
	});
});

$(
	'p.component, .component_label, .announcements p, .disclosures th, .disclosures td p'
).text(function(i, text) {
	return text.replace(/_/g, ' ');
});

(function($) {
	$('.open-lightbox').on('click', function(e) {
		e.preventDefault();
		var image = $(this).attr('href');
		$('html').addClass('no-scroll');
		$('body').append(
			'<div class="lightbox-opened"><img src="' + image + '"></div>'
		);
	});

	$('body').on('click', '.lightbox-opened', function() {
		$('html').removeClass('no-scroll');
		$('.lightbox-opened').remove();
	});

	$('.modal-open').click(function() {
		var target = $(this).attr('data-target');
		if (target) {
			$(target).show();
		}
		return;
	});

	$('.modal-form .body .exit').click(function() {
		$(this)
			.parents('.modal-form')
			.hide();
		return;
	});
})(jQuery);
